import axios from 'axios'
import * as Sentry from '@sentry/browser'

export default async ({ Vue }) => {
  Vue.prototype.$axios = axios

  axios.interceptors.request.use(function (config) {
    const disableCache = `disable-cache=${Math.random()}`
    if (config.url.indexOf('?') > 0) {
      config.url = `${config.url}&${disableCache}`
    } else {
      config.url = `${config.url}?${disableCache}`
    }
    return config
  }, function (error) {
    Sentry.withScope((scope) => {
      if (error && error.config) {
        scope.setExtra('axios-config', error.config)
      }
      Sentry.captureException(error)
    })
    return Promise.reject(error)
  })
}
